// src/contexts/AuthContext.jsx
import React, { createContext, useState, useContext } from 'react';

// Erstelle den Context mit initial undefined
export const AuthContext = createContext(undefined);

// Provider-Komponente zur Verwaltung des Authentifizierungsstatus
export const AuthProvider = ({ children }) => {
  const [userId, setUserId] = useState(null); // userId wird initial auf null gesetzt

  return (
    <AuthContext.Provider value={{ userId, setUserId }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom Hook zum Zugriff auf den Context
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
